import { createContext, useContext } from "react";

export interface ResizableSidebarContextValue {
    /** True only when collapsed AND on a desktop breakpoint. */
    isCollapsed: boolean;
    /** Toggle collapsed state. */
    onToggle: () => void;
    /** Current sidebar pixel width. Useful for children to adapt their layout. */
    width: number;
    /** Whether the viewport is >= 1024 px (lg). */
    isDesktop: boolean;
    /**
     * True when this context was provided by an actual ResizableSidebar.
     * Allows children to show/hide sidebar-specific UI (e.g. a collapse button).
     */
    hasSidebar: boolean;
}

export const ResizableSidebarContext = createContext<ResizableSidebarContextValue>({
    isCollapsed: false,
    onToggle: () => {},
    width: 280,
    isDesktop: true,
    hasSidebar: false,
});

/**
 * Consume the nearest ResizableSidebar's state.
 * Safe to call outside a ResizableSidebar — returns sensible defaults.
 */
export const useResizableSidebar = () => useContext(ResizableSidebarContext);
